import { render } from "./TeamJersey.vue?vue&type=template&id=42206d46"
import script from "./TeamJersey.vue?vue&type=script&lang=js"
export * from "./TeamJersey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__